<app-header></app-header>

<section class="bv-generator-page">
  <div class="bv-generator-page__panel">
    <tools-credential-generator (historyClick)="openHistoryDialog()" />
  </div>
</section>
